import React from "react";
import { PropsWithChildren, useCallback, useEffect, useState } from "react";
import { SingleLineContext } from "./context";
import { SingleLineConfig } from "./types";
import diagramHywind from "../diagram-hywind.json";

export const SingleLineProvider = ({ children }: PropsWithChildren) => {
  const [singleLine, setSingleLine] = useState<SingleLineConfig>();

  const toggleTurbineStatus = (id: string) => {
    if (!singleLine) return;

    const turbine = singleLine.nodes.find((turbine) => turbine.data.id === id);

    if (turbine?.data.status) {
      turbine.data.status.isTurnedOff = !turbine.data.status.isTurnedOff;
      setSingleLine({ ...singleLine });
    }
  };

  const toggleTurbineInterlock = (id: string) => {
    if (!singleLine) return;

    const turbine = singleLine?.nodes.find((turbine) => turbine.data.id === id);

    if ((turbine?.data as any)?.interlock !== undefined) {
      (turbine?.data as any).interlock = !(turbine?.data as any).interlock;
    } else {
      (turbine?.data as any).interlock = true;
    }

    setSingleLine({ ...singleLine });
  };

  const toggleTurbinePersonnel = (id: string) => {
    if (!singleLine) return;

    const turbine = singleLine?.nodes.find((turbine) => turbine.data.id === id);

    if ((turbine?.data as any)?.personnel !== undefined) {
      (turbine?.data as any).personnel = !(turbine?.data as any).personnel;
    } else {
      (turbine?.data as any).personnel = true;
    }

    setSingleLine({ ...singleLine });
  };

  const getNode = useCallback(
    (id: string) => {
      const turbine = singleLine?.nodes.find(
        (turbine) => turbine.data.id === id,
      );

      return turbine?.data;
    },
    [singleLine],
  );

  useEffect(() => {
    if (singleLine) {
      localStorage.setItem("single-line-hywind", JSON.stringify(singleLine));
    }
  }, [singleLine]);

  useEffect(() => {
    const singleLineSaved = localStorage.getItem("single-line-hywind");
    setSingleLine(
      singleLineSaved === null ? diagramHywind : JSON.parse(singleLineSaved),
    );
  }, []);

  return (
    <SingleLineContext.Provider
      value={{
        singleLineConfig: singleLine,
        getNode,
        toggleTurbineStatus,
        toggleTurbineInterlock,
        toggleTurbinePersonnel,
      }}
    >
      {children}
    </SingleLineContext.Provider>
  );
};
